export { MedicalCardRegistry } from './ui';
